import React from "react";
import { GET } from "Common/api";
import SettingStore from "stores/settings";
import withLanguageContext from "lib/hocs/withLanguageContext";

class PersonalGoalsDropdown extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentWillMount() {
    const isBt = SettingStore.isBt();
    let year = this.props.year;

    if (!year) year = new Date().getFullYear();

    if (isBt) {
      year = null;
    }

    let goals = await GET(
      `v1/user/goalsnohierarchy?${new URLSearchParams({
        personalId: this.props.personalId,
        year,
      })}`,
    );

    this.setState({
      ready: true,
      goals,
      currentValue: this.props.defaultValue,
    });
  }

  setValue(e) {
    this.setState({ currentValue: e.target.value });

    if (this.props.updateParentState)
      this.props.updateParentState(e.target.value);
  }

  render() {
    if (!this.state || !this.state.ready) return <div />;
    const { languageContext } = this.props;
    return (
      <select
        id={this.props.id}
        defaultValue={this.props.defaultValue}
        onChange={this.setValue.bind(this)}
      >
        <option key={0} value="">
          {`- ${languageContext("disconnectbusinessgoals")} -`}
        </option>
        {this.state.goals.map((goal) => (
          <option key={goal.id} value={goal.id}>
            {goal.title}
          </option>
        ))}
      </select>
    );
  }
}

export default withLanguageContext(PersonalGoalsDropdown, "TalentManagement");
